import { Divider, Typography } from "antd";
import React from "react";
import ProductList from "./ProductList";
import "./ProductStyles.css";

const { Title } = Typography;

const ProductManagement = () => {
    // const [refreshKey, setRefreshKey] = useState(0);
    // const [selectedProduct, setSelectedProduct] = useState(null);
    const isMobile = window.innerWidth < 768;

    // Esta función se ejecutará cuando se agregue un nuevo producto
    // const handleProductAdded = () => {
    //     // Incrementar el key para forzar la actualización de la lista de productos
    //     setRefreshKey((prevKey) => prevKey + 1);
    // };

    // // Esta función se ejecutará cuando se edite un producto
    // const handleProductEdited = (product) => {
    //     setSelectedProduct(product);
    // };

    // // Esta función se ejecutará cuando se actualice un producto
    // const handleProductUpdated = () => {
    //     // Limpiar el producto seleccionado e incrementar el key para actualizar la lista
    //     setSelectedProduct(null);
    //     setRefreshKey((prevKey) => prevKey + 1);
    // };

    return (
        <div className="product-management-container">
            <Title level={2}>{isMobile ? "Productos" : "Gestión de Productos"}</Title>
            <Divider />

            {/* <Row gutter={[24, 24]}>
                <Col xs={24} lg={12}>
                    <Card>
                        <ProductForm
                            onProductAdded={handleProductAdded}
                            onProductUpdated={handleProductUpdated}
                            productToEdit={selectedProduct}
                        />
                    </Card>
                </Col> */}

            {/* <Col xs={24} lg={12}> */}
            <ProductList
            // refreshTrigger={refreshKey}
            // onEditProduct={handleProductEdited}
            />
            {/* </Col>
            </Row> */}
        </div>
    );
};

export default ProductManagement; 